import React, { useContext, useState, forwardRef } from 'react';
import { useTranslation } from '@/app/i18n/client';
import languageContext from '@/context/language';
import Popper from '@mui/base/Popper';
import ClickAwayListener from '@mui/base/ClickAwayListener';
import { COA_ROOT_DOMAIN } from '@/app/utils/constant';
import Link from 'next/link';
interface Product {
  coa?: any;
}

export const ProductDocument = forwardRef<HTMLInputElement, Product>(function ProductDocument(props, ref) {
  const { lang } = useContext(languageContext);
  const { t } = useTranslation(lang, 'orderhistory');
  const { coa } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClickAway = () => {
    setIsOpen(false);
  };

  const id = isOpen ? 'product-documents-popper' : undefined;

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className="print:hidden">
        <div
          className="border border-solid border-gray-300 w-max px-4 py-1 rounded-2xl mr-4 font-normal text-xs cursor-pointer"
          ref={(elm) => setAnchorEl(elm)}
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          {t('product.documents')}
          <i className="icon-8-caret-down mt-3 ml-2" />
        </div>

        <Popper id={id} open={isOpen} anchorEl={anchorEl} placement="bottom" className="print:hidden">
          <div
            tabIndex={-1}
            role="dialog"
            aria-label="product documents"
            className="m-0 inset-[0px_auto_auto_0px] w-full bg-white shadow-[0_6px_8px_0_rgba(34,34,34,0.2)] w-[400px] pb-2"
          >
            <div className="border-0 border-b border-solid border-gray-450 px-6 text-base font-medium h-[53px] flex flex-row flex-nowrap justify-between items-center">
              {t('product.documents')}
            </div>
            <div className="h-4 text-[#222] text-sm tracking-[0] w-full flex flex-row flex-nowrap justify-between pl-4 pr-6 py-3">
              {t('coa')}
            </div>
            <div className="mt-4">
              {coa &&
                coa.length > 0 &&
                coa.map((coa, index) => {
                  return (
                    <div key={index} className="pl-6 pr-6">
                      <Link
                        target="_blank"
                        download
                        href={coa.path ? (coa.path?.startsWith('http') ? coa.path : COA_ROOT_DOMAIN + coa.path) : ''}
                        className="flex"
                      >
                        <i className="icon-16-docs-pdf-mono" />
                        <p className="pl-2">{coa.fileName}</p>
                      </Link>
                    </div>
                  );
                })}
              {(!coa || coa.length === 0) && <div className="pl-6 pr-6 text-gray-600 text-sm">{t('no.docs')} </div>}
            </div>
          </div>
        </Popper>
      </div>
    </ClickAwayListener>
  );
});
